<template>
  <div>
    <div
      class="process_list"
      v-if="$store.getters.allAuthUser && !basisVersion"
      style="
        background-color: #fff5e6;
        border-color: #ffebcc;
        padding: 5px;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
      "
    >
    <!--  流程引导    -->
      <p style="display: flex; align-items: center">
        <i class="el-icon-warning" style="color: #f8b762; margin: 0 10px"></i>
        <span class="process_list_num">1</span>
        <span v-if="isInDingTalk">创建印章</span>
        <a v-else href="https://www.junziqian.com/help_detail-8.html" target="_blank">创建印章</a>
        <i class="el-icon-right icon_size"></i>
        <span class="process_list_num">2</span>
        <span v-if="isInDingTalk">给印章关联审批流程(可选)</span>
        <a v-else href="https://www.junziqian.com/help_detail-38.html" target="_blank">给印章关联审批流程(可选)</a>
        <i class="el-icon-right icon_size"></i>
        <span class="process_list_num">3</span>
        <span v-if="isInDingTalk">将印章授权给成员使用</span>
        <a v-else href="https://www.junziqian.com/help_detail-9.html" target="_blank">将印章授权给成员使用</a>
      </p>
    </div>
    <el-tabs ref="tabs" v-model="tabAct" @tab-click="refreshList" style="min-height: calc(100vh - 210px); background-color: #ffffff">
      <!--
        拥有某个权限可以显示。
        为了兼容以前的数据，在两个子权限都没有的情况下，可以显示出来
        （如果只有父级权限说明是以前的数据。可以拥有子权限）
        -->
      <!-- v-if="perms.includes(gantConf.enterpriseSealManage)" -->
      <el-tab-pane label="企业印章" name="mianSign">
        <my-sign
          v-if="tabAct === 'mianSign'"
          :tabAct.sync="tabAct"
          title="企业印章"
          @callbackFn="callbackFn"
        ></my-sign>
      </el-tab-pane>
      <!--      <el-tab-pane v-if="showGrant" label="授权给我的印章" name="grantToMe">-->
      <!--        <give-to-me></give-to-me>-->
      <!--      </el-tab-pane>-->
      <el-tab-pane label="成员用印审批" name="signSet" v-if="!basisVersion">
        <sign-set v-if="tabAct === 'signSet'"></sign-set>
      </el-tab-pane>
      <el-tab-pane label="" name="grant" disabled>
        <grant ref="grantComp" :tabAct.sync="tabAct" :defaultTemId="defaultTemId" v-if="tabAct === 'grant'"></grant>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// 组件
import grant from "../../components/console/seal/grant.vue";
import mySign from "../../components/console/seal/mySign.vue";
import giveToMe from "../../components/console/seal/giveToMe.vue";
import signSet from './components/signSet.vue'
import { gantConf } from "../../assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  data () {
    return {
      isInDingTalk,
      tabAct: "mianSign",
      gantConf,
      defaultTemId: 0,
    };
  }, // data end
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    showGrant () {
      let account = this.allAuthUser.manCorpUser,
        current = this.currentAuthUser;
      // true 加入的企业。false 自己管理的企业。加入的企业才显示授权给我的印章页面
      let grant = !account || account.corpId != current.corpId;
      return grant;
    },
    //基础版本
    basisVersion() {
      return this.$store.getters.allAuthUser.accountInfoVO.userType === 1 && this.$store.getters.allAuthUser.accountInfoVO.layoutVersion === 1;
    },
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    }
  },
  components: {
    grant,
    mySign,
    giveToMe, signSet
  },
  methods: {
    callbackFn(val) {
      this.defaultTemId = val;
      this.tabAct = 'grant';
    },
    refreshList (targetName) {
      (targetName.name == "grant" || targetName == "grant") &&
        this.$refs.grantComp &&
        this.$refs.grantComp.getAllSeals();
    }
  }
};
</script>

<style lang="less">
.el-tabs__header {
  margin: 0;
}
.el-tabs--bottom .el-tabs__header.is-bottom {
  margin-top: 0;
}
.el-tabs__nav-scroll {
  background-color: #fff;
}
.el-tabs__item {
  font-weight: bold;
  font-size: 15px;
  padding: 0 12px !important;
}
.el-tabs__active-bar {
  display: none;
}
.el-tabs__item.is-active {
  color: #ec1c1c;
}
.el-tabs__item:hover {
  color: #ec1c1c;
}
.el-tabs__nav-wrap::after {
  height: 1px;
}
.process_list {
  color: #606266;
  font-size: 14px;
  .process_list_num {
    display: inline-block;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    border: 2px solid #606266;
    border-radius: 50%;
    margin-right: 6px;
  }
  .icon_size {
    margin: 0 20px;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/seal.vue